import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ height = "h-14" }) => (
  <Link to="/" className="flex items-center group shrink-0" data-testid="logo-home-link" aria-label="ACRE — Al Casa Real Estate, home">
    <img
      src="/images/logo.png"
      alt="ACRE — Al Casa Real Estate"
      className={`${height} w-auto object-contain transition-opacity duration-300 group-hover:opacity-85`}
    />
  </Link>
);

export default Logo;
